import { createFileRoute } from '@tanstack/react-router';
import CargoTelView from '../admin/cargo-tel/view';
export const Route = createFileRoute('/admin/cargo-tel/configs')({ component: CargoTelView });
